export const notification_preferences_info_message = 'Вы можете настроить получение уведомлений по разделам ЛКП, установив чекбоксы рядом с событиями, по которым могут быть получены уведомления.';

export const unread_notifications_info_message = 'Вы можете настроить выделение строк жирным шрифтом в нужных разделах. Если отключить чекбокс с названием раздела, то при обновлении данных в этом разделе строки не будут выделяться жирным.';

export const popup_notifications_limit = 3;
